import React, { useRef } from 'react';
import { Box, Grid, TextField, Typography } from '@material-ui/core';
import useResolution from 'src/hooks/useResolution';
import { normalizeToSqlDatetime } from 'src/utils';
import { dateToday } from 'src/utils';

interface Props {
  fromDateValue?: string | null;
  toDateValue?: string | null;
  size?: 'small' | 'medium';
  title?: string | null;
  onChangeFromDate: (date: string) => void;
  onChangeToDate: (date: string) => void;
}

export const DatePickerRangeComponentV2 = ({
  fromDateValue = null,
  toDateValue = null,
  size = 'small',
  title,
  onChangeFromDate,
  onChangeToDate
}: Props) => {
  const { xs, md } = useResolution();

  const fromDateRef = useRef<HTMLInputElement | null>(null);
  const toDateRef = useRef<HTMLInputElement | null>(null);

  const normalizeDateFormat = (dateStr: string | null) => {
    if (!dateStr) return null;

    const formattedDate = normalizeToSqlDatetime(dateStr);

    return formattedDate === 'Invalid date' ? null : formattedDate;
  };

  return (
    <>
      <Grid container spacing={2}>
        {title ? (
          <Grid item xs={12}>
            <Typography align="center" variant="h5">
              {title}
            </Typography>
          </Grid>
        ) : null}
        <Grid item xs={6} style={{ paddingRight: '1em' }}>
          <Box display="flex" flexDirection="column">
            <TextField
              type="datetime-local"
              variant="outlined"
              label="Start Date"
              InputLabelProps={{ shrink: true }}
              size={size}
              value={normalizeDateFormat(fromDateValue ?? null) || ''}
              inputRef={fromDateRef}
              inputProps={{
                min:  new Date().toISOString().slice(0, 16), 
                style: {
                  ...(xs && { fontSize: '.8em' }),
                  ...(md && { fontSize: '1em' })
                }
              }}
              onChange={(e) => onChangeFromDate(e.target.value)}
            />
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box display="flex" flexDirection="column">
            <TextField
              label="End Date"
              type="datetime-local"
              variant="outlined"
              size={size}
              value={normalizeDateFormat(toDateValue ?? null) || ''}
              inputRef={toDateRef}
              InputLabelProps={{ shrink: true }}
              inputProps={{
                min: fromDateValue ?? dateToday(),
                style: {
                  ...(xs && { fontSize: '.8em' }),
                  ...(md && { fontSize: '1em' })
                }
              }}
              onChange={(e) => onChangeToDate(e.target.value)}
              disabled={!fromDateValue}
            />
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
